export default __webpack_public_path__ + "static/media/InfoIcon.93eac086.svg";